import styled from 'styled-components';
import { Colors, mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  display: grid;

  grid-auto-flow: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  cursor: pointer;
`;
export const PopperContainer = styled.div `
  padding: 16px;
  border: 1px solid ${Colors.GS500};
  background-color: ${Colors.GS0};

  ${mediaQueries.tablet} {
    width: 320px;
  }
`;
export const PillSwitchContainer = styled.div `
  margin-bottom: 16px;
`;
export const UploadContainer = styled.div `
  height: 160px;
`;
export const UploadInfo = styled.div `
  margin-top: 12px;
  font-size: 14px;
  line-height: 1.5;
  color: ${Colors.GS600};
`;
export const Emoji = styled.div `
  position: relative;
  top: 1px;

  font-size: 26px;
  line-height: 24px;
  font-family: 'Segoe UI Emoji';
  font-weight: normal;
`;
export const Image = styled.img `
  width: 24px;
  height: 24px;
  object-fit: contain;
`;
